<template>
  <div id="app">
    <div ref="main" />
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import Promise from 'bluebird'
import { mapActions, mapMutations, mapState } from "vuex";
import _ from "lodash";

import eventBus from "./utils/eventBus";
import snackbar from "./components/snackbar.vue";
import { getStoredUser } from "./utils/session";
import { syncPwaInstallState } from "./utils/pwaInstall";
import { syncPushSubscription } from "./utils/pushNotifications";

export default {
  components: {},
  data() {
    return {
      isUserLoaded: false
    };
  },
  computed: {
    ...mapState(["user", "profilePic"]),
  },
  watch: {
    user() {
      syncPwaInstallState(this.user);
      syncPushSubscription(this.user);
    },
  },
  async created() {

    this.loadUserFromLocalStorage();
    await this.$store.dispatch("checkUserData");
    if (this.user) {
      await this.loadProfilePicture();
    }
    await Promise.all([this.getCountriesAll()])
    eventBus.$on("createSnackbar", (payload) => this.createSnackbar(payload));
    syncPwaInstallState(this.user);
    syncPushSubscription(this.user);
    window.addEventListener("resize", this.onPwaResize);
    eventBus.$on("pwa-app-installed", this.onPwaInstalled);

    if (document.referrer) {
      const referrer = new URL(document.referrer).hostname;
      localStorage.setItem("referrer", referrer);
    }
    
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onPwaResize);
    eventBus.$off("pwa-app-installed", this.onPwaInstalled);
  },
  methods: {
    ...mapMutations(["updateUser"]),
    ...mapActions(["loadProfilePicture", "getCountriesAll"]),

    loadUserFromLocalStorage() {
      const user = getStoredUser();
      if (user) {
        this.$store.commit("updateUser", user);
      }
    },
    onPwaResize() {
      syncPwaInstallState(this.user);
    },
    onPwaInstalled() {
      syncPushSubscription(this.user, { forceAsk: true });
    },
    createSnackbar(payload) {
      const ComponentClass = Vue.extend(snackbar);
      const instance = new ComponentClass({
        propsData: payload,
      });
      instance.$mount(); // pass nothing

      this.$refs.main.appendChild(instance.$el);
      setTimeout(() => {
        this.$refs.main.removeChild(instance.$el);
      }, payload.timeoutInMS || 3000);
    },
  },
};
</script>
